module.exports = __webpack_public_path__ + "static/media/123-british-columbia.713f5d79.svg";